/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let UpdateProfileUrl = root.updateProfileUrl.link
let UpdateProfileAvatarUrl = root.updateProfileAvatarUrl.link
let mobileNoURL = root.mobileNoUrl.link
let mobileNoVerifyURL = root.mobileNoVerifyUrl.link

import Vue from 'vue'
export default {
  state: {
    updateProfileState:{}
  },
  mutations: {
    updateProfileMut(state, value) {
      Vue.set(state, 'updateProfileState', value);
    }
  },
  actions: {
    // Update Profile Function
    updateProfileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(UpdateProfileUrl, payload).then(res => {
              context.commit('updateProfileMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Profile Avatar Function
    updateProfileAvatarFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(UpdateProfileAvatarUrl, payload, {
              // headers: {
              //   'Content-Type': null
              // }
            }).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Profile Avatar Function
    removeProfileAvatarFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(UpdateProfileAvatarUrl, payload, {
              // headers: {
              //   'Content-Type': null
              // }
            }).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Mobile No Create Function
    mobileNoCreatedFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(mobileNoURL, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Mobile No Verify Create Function
    mobileNoVerifiedFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(mobileNoVerifyURL, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    }
  },
  getters: {
    updateProfileGetters: state => state.updateProfileState
  }
}